export const removeSpaceOnFirstCharacter = (event) => {
    if (event.target.selectionStart === 0 && event.code === "Space") {
        event.preventDefault();
    }
};
